export default __webpack_public_path__ + "static/media/squares800.caffbd1f.jpg";